const body = window.getComputedStyle(document.querySelector('body'));

const appDefaultFont = {
	size: _.toNumber(_.trimEnd(body.fontSize, 'px')),
	family: body.fontFamily,
	weight: body.fontWeight
};
module.exports = appDefaultFont;